module.exports = __webpack_public_path__ + "static/goldbot-eb5a8d6697dd22f1349f262fa27b43c5.jpg";